import * as React from "react";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return (
    <MuiAlert
      elevation={6}
      ref={ref}
      variant="filled"
      {...props}
      sx={{
        backgroundColor: "#29214F",
        borderBottomColor: "#D5E8F6",
        color: "#FAFAFA",
        display: "flex",
        alignItems: "center",
        fontFamily: "GT Walsheim Pro",
        borderBottomWidth: "4px",
        borderRadius: "8px",
        zIndex: 9999,
        "& .MuiAlert-icon": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: "8px",
        },
        ...props.sx,
      }}
    />
  );
});

export function InfoAlert({
  isOpen,
  message,
  anchorOrigin,
  autoHideDuration,
  vertical = "top",
  isDesktop = false,
}) {
  const [open, setOpen] = React.useState(isOpen);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar
        autoHideDuration={autoHideDuration ?? 5000}
        open={open}
        onClose={handleClose}
        anchorOrigin={
          anchorOrigin ?? {
            vertical: vertical,
            horizontal: isDesktop ? "right" : "center",
          }
        }
      >
        <Alert
          onClose={handleClose}
          severity="info"
          sx={{ width: isDesktop ? "370px" : "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
